import { signal } from '@preact/signals-react';

export const isSidebarVisible = signal(false);
